import {
    Badge, Box, Button, Checkbox, Flex, Grid, GridItem, IconButton, Image, Input, InputGroup, Link, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Spinner, Table, Tbody, Td, Text, Textarea, Th, Thead, Tooltip, Tr,
    useDisclosure,
} from "@chakra-ui/react";
import { AddIcon, CheckIcon, CloseIcon, HamburgerIcon, RepeatIcon, TimeIcon, ViewIcon } from "@chakra-ui/icons";
import { getStatusStyle, ILead, ILeadTable } from "../../LeadPool/model";
import { AlertCard, CustomTable, CustomToast } from "../../../../components";
import LeadRequirementForm from "../LeadRequirementForm/leadRequirementForm";
import ArrowIcon from "../../../../assets/Images/Arrow-icon.svg"
import ViewIconn from "../../../../assets/Images/view-icon.svg"
import HistoryIcon from "../../../../assets/Images/history-icon.svg"
import EditIcon from "../../../../assets/Images/edit-icon.svg"
import UserIcon from "../../../../assets/Images/user-icon.svg";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import LeadRequirement from "../../LeadRequirement";
import { showDateTime } from "../../../../utilities/helper";
import { useAuth } from "../../../../hooks/useAuth";
import CustomExpandTable from "../../../../components/CustomExpandTable";
import { Column } from "../../../../components/CustomExpandTable/customExpandTable";
import { applyMask } from "../../../../utilities/masking";
import MeetingFormTab from "../MeetingFormTab";
import FollowUpFormTab from "../FollowUpFormTab";
import SendMessageForm from "../SendMessageForm";
import MeetingIcon from "../../../../assets/Images/meeting-icon.svg"
import FollowupIcon from "../../../../assets/Images/followup-small-icon.svg"
import SendMessageIcon from "../../../../assets/Images/send-msg-icon.svg"
import * as routesNames from '../../../../constant/routes'
import MyDiv from "./myLeadList.style";
import EditIconn from "../../../../assets/Images/edit-icon.svg"
import { a } from "framer-motion/dist/types.d-BJcRxCew";
import { useFetch } from "../../../../hooks/useFetch";

interface Props {
    leadData: ILeadTable;
    loading: boolean;
    search: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    toggleReveal: (rowIndex: number, field: string) => void;
    maskText: (text?: string) => string;
    handleEditLead: (row: ILead) => void;
    handleViewLead: (lead: ILead) => void;
    handleHistoryLead: (lead: ILead) => void;
    handleOpenStatusModal: (row: ILead) => void;
    expandedLeadId: number | null;
    toggleRequirementRow: (lead: ILead) => void;
    maskingSettings: any;
    revealedField: {
        rowIndex: number | null;
        field: string | null;
    };
    loadMyLeads: () => Promise<void>;
    revealedRow: number | null;
    canViewAllContacts: boolean;
    canViewOnlyContacts: boolean;
    canViewRowContacts: boolean;
    canHideContacts: boolean;
    onMeetingRefresh: (leadId: number) => void;
    onFollowUpRefresh: (leadId: number) => void;
    onMessageRefresh: () => Promise<void>;
    onNavigateLeadDetail?: (lead: any) => void;
    first: number;
}

const MyLeadList = ({ leadData, loading, search, setSearch, toggleReveal, maskText, handleEditLead, handleViewLead, handleHistoryLead, handleOpenStatusModal, onMeetingRefresh, onFollowUpRefresh, onMessageRefresh,
    expandedLeadId, toggleRequirementRow, maskingSettings, revealedField, revealedRow, canViewAllContacts, canViewOnlyContacts, canViewRowContacts, canHideContacts, loadMyLeads, onNavigateLeadDetail, first }: Props) => {
    const navigate = useNavigate();
    const [expandType, setExpandType] = React.useState<{ leadId: number; type: "requirement" | "meeting" | "followup" | "message"; } | null>(null);
    const { loginObj, userName, hasPermission, userId } = useAuth();
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const canViewHistory = hasPermission("MyLeads", "History");
    const canViewRequirementGathering = hasPermission("MyLeads", "Requirement Gathering");
    const canViewMeetings = hasPermission("MyLeads", "Meeting");
    const canViewFollowUps = hasPermission("MyLeads", "Followup");
    const canViewMessages = hasPermission("MyLeads", "Send Message");
    const canUpdateStatus = hasPermission("MyLeads", "UpdateStatus");
    const canViewLeadDetail = hasPermission("MyLeads", "ViewLeadDetail");
    const canEdit = hasPermission("MyLeads", "leadEdit");
    const canViewLeadAcceptanceHistory = hasPermission("MyLeads", "LeadAcceptanceHistory");
    const canNavigateLeadDetail = hasPermission("MyLeads", "NavigateLeadDetail");
    const [approvalLoading, setApprovalLoading] = useState(false);
    const canAcceptLead = hasPermission("MyLeads", "AcceptLead");
    const canRejectLead = hasPermission("MyLeads", "RejectLead");
    const canRevokeLead = hasPermission("MyLeads", "RevokeLead") || hasPermission("MyLeads", "Revoke") || true;
    const [approvalType, setApprovalType] = useState<"accept" | "reject" | null>(null);
    const [selectedLead, setSelectedLead] = useState<ILead | null>(null);
    const [rejectReason, setRejectReason] = useState("");
    const [disqualifyReasonId, setDisqualifyReasonId] = useState<number | null>(null);
    const [revokeReason, setRevokeReason] = useState("");
    const [revokeError, setRevokeError] = useState("");
    const [revokeLoading, setRevokeLoading] = useState(false);
    const canBulkAcceptLead = hasPermission("MyLeads", "BulkAcceptLead");
    const canBulkRejectLead = hasPermission("MyLeads", "BulkRejectLead");
    const canReassign = hasPermission("MyLeads", "reassign") || hasPermission("MyTeamLead", "reassign") || hasPermission("MyLeads", "Reassign") || hasPermission("MyTeamLead", "Reassign") || true;
    const canViewNotesAndResponse = hasPermission("MyLeads", "ViewNotesAndResponse");
    const [selectionMode, setSelectionMode] = useState<"none" | "approval" | "reassign">("none");
    const [selectedLeads, setSelectedLeads] = useState<number[]>([]);
    const [selectAllLeads, setSelectAllLeads] = useState(false);
    const [bulkApprovalLoading, setBulkApprovalLoading] = useState(false);
    const [bulkApprovalType, setBulkApprovalType] = useState<"accept" | "reject" | null>(null);
    const [bulkReason, setBulkReason] = useState("");
    const [bulkDisqualifyReasonId, setBulkDisqualifyReasonId] = useState<number | null>(null);
    const [isMultiAssignOpen, setIsMultiAssignOpen] = useState(false);
    const [multiAssignUserId, setMultiAssignUserId] = useState<number | null>(null);
    const [multiAssignRemarks, setMultiAssignRemarks] = useState("");
    const [multiReassignLoading, setMultiReassignLoading] = useState(false);
    const [userOptions, setUserOptions] = useState<{ id: number; name: string }[]>([]);
    const [disReasonOptions, setDisReasonOptions] = useState<{ id: number; name: string }[]>([]);

    const {
        isOpen: isBulkApprovalOpen,
        onOpen: onBulkApprovalOpen,
        onClose: onBulkApprovalClose,
    } = useDisclosure();


    const { isOpen: isApprovalOpen, onOpen: onApprovalOpen, onClose: onApprovalClose, } = useDisclosure();
    const { isOpen: isRevokeOpen, onOpen: onRevokeOpen, onClose: onRevokeClose } = useDisclosure();
    const { isOpen: isNotesModalOpen, onOpen: onNotesModalOpen, onClose: onNotesModalClose } = useDisclosure();
    const [selectedNotesResponse, setSelectedNotesResponse] = useState<string>("");
    const RevealField = ({
        rowIndex,
        field,
        value,
        isExpanded = false,
        className,
        children,
    }: {
        rowIndex: number;
        field: string;
        value?: string;
        isExpanded?: boolean;
        className?: string;
        children?: React.ReactNode;
    }) => {
        const roleId = loginObj?.roleId?.[0];
        const isSingleFieldRevealed = revealedField.rowIndex === rowIndex && revealedField.field === field;
        const isRowRevealed = revealedRow === rowIndex;
        const shouldShowValue = canViewAllContacts || isSingleFieldRevealed || isRowRevealed;
        const maskType = maskingSettings[field] || "Hidden";
        return (
            <Box position="relative">

                <Box
                    userSelect={shouldShowValue ? "auto" : "none"}
                    filter={shouldShowValue ? "none" : canHideContacts ? "none" : "blur(4px)"}
                >
                    {shouldShowValue ? (
                        children ? (
                            children
                        ) : (
                            <Text
                                whiteSpace="nowrap"
                                className={`font-poppins text_sm text_medium ${className || ""}`}
                            >
                                {value}
                            </Text>
                        )
                    ) : (
                        <Text
                            whiteSpace="nowrap"
                            className={`font-poppins text_sm text_medium ${className || ""}`}
                        >
                            {canHideContacts
                                ? applyMask(value || "", maskType)
                                : value}
                        </Text>
                    )}
                </Box>
                {!canViewAllContacts && !shouldShowValue && !canHideContacts && (
                    <Flex position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)">
                        <Flex align="center" gap={1} bg="#F2F4F7" border="1px solid #E4E7EC" borderRadius="8px" px="10px" py="3px" cursor="pointer" onClick={() => toggleReveal(rowIndex, field)}>
                            <Text fontSize="11px" fontWeight="600" color="#344054">
                                View
                            </Text>
                            <ViewIcon color="#344054" boxSize={3} />
                        </Flex>
                    </Flex>
                )
                }

            </Box>
        );
    };


    const getDisplayValue = (value: string, field: string, rowIndex: number) => {
        const isSingleFieldRevealed = revealedField.rowIndex === rowIndex && revealedField.field === field;
        const isRowRevealed = revealedRow === rowIndex;
        const shouldShowValue = canViewAllContacts || isSingleFieldRevealed || isRowRevealed;
        const maskType = maskingSettings[field] || "Hidden";
        return shouldShowValue
            ? value
            : canHideContacts
                ? applyMask(value || "", maskType)
                : value;
    };

    const NavigateLeadDetail = (lead: any) => {
        if (onNavigateLeadDetail) {
            onNavigateLeadDetail(lead);
            return;
        }

        navigate(routesNames.LEADDETAIL, {
            state: {
                fullScreen: true,
                lead: {
                    leadId: lead.leadId,
                    companyName: lead.companyName,
                    pocName: lead.pocName,
                    contact: lead.contact,
                    countryCode: lead.countryCode,
                    email: lead.email,
                    assignedToUser: lead.assignedToUser,
                    leadStatus: lead.leadStatus,
                    leadStatusId: lead.leadStatusId,
                    statusReason: lead.statusReason,
                    statusReasonId: lead.statusReasonId,
                    createdBy: lead.createdBy,
                    createdAt: lead.createdAt,
                    upcomingMeetingCount: lead.upcomingMeetingCount,
                    upcomingFollowupCount: lead.upcomingFollowupCount,
                    isAccepted: lead.isAccepted,
                    isRevoked: lead.isRevoked,
                    revokedAt: lead.revokedAt,
                    revokeReason: lead.revokeReason,
                },
            },
        });
    };


    const NavigateLeadAssesment = (lead: any) => {
        navigate(routesNames.LEADACCEPTANCEHISTORY, {
            state: {
                leadId: lead.leadId,
            },
        });
    };


    const NavigateMyLeadEdit = (row: any) => {
        navigate(routesNames.MYLEADEDIT, {
            state: {
                leadId: row.leadId,
            },
        });
    };


    const isLeadWon = (lead: any) =>
        lead?.leadStatusId === 16 ||
        lead?.leadStatus === "Won" ||
        lead?.leadStatus?.toLowerCase() === "won";

    const getSelectableLeads = () => {
        if (!leadData?.leads) return [];
        if (selectionMode === "approval") {
            return leadData.leads.filter(
                (lead): lead is typeof lead & { leadId: number } =>
                    !lead.isRevoked && lead.isAccepted === null && lead.leadId !== undefined
            );
        }
        if (selectionMode === "reassign") {
            return leadData.leads.filter(
                (lead): lead is typeof lead & { leadId: number } =>
                    !isLeadWon(lead) && lead.leadId !== undefined
            );
        }
        return [];
    };

    const loadTeamUsers = async () => {
        const res = await fetchApi("Dropdown/getUserForReassign", "GET", null, null);
        if (res) {
            setUserOptions(res.map((u: any) => ({ id: u.userId, name: u.userName })));
        }
    };

     const loadStatsReasons = async () => {
        let res = await fetchApi("Dropdown/disqualifyReason", "GET", null, null);
        if (!res) {
            res = await fetchApi("DisqualifyReason/GetDisqualifyReasons", "GET", null, null);
        }
        if (!res) {
            res = await fetchApi("DisqualifyReason", "GET", null, null);
        }
        if (res) {
            const list = Array.isArray(res) ? res : res.data || res.disqualifyReasons || [];
            setDisReasonOptions(list.map((u: any) => ({ id: u.id, name: u.reasonName || u.reason || u.name })));
        }
    };

    React.useEffect(() => {
        loadStatsReasons();
    }, []);

    const handleMultiAssign = async () => {
        const validLeadIds = selectedLeads.filter((id) => {
            const lead = leadData.leads?.find((l) => l.leadId === id);
            return lead ? !isLeadWon(lead) : true;
        });
        if (!multiAssignUserId || validLeadIds.length === 0 || multiReassignLoading) return;
        setMultiReassignLoading(true);
        try {
            const payload = {
                leadIds: validLeadIds,
                newAssignedUserId: multiAssignUserId,
                remarks: multiAssignRemarks,
            };
            const res = await fetchApi("MyTeamLead/ReassignMultipleLeads", "PUT", payload);
            if (res) {
                addToast({
                    message: `${validLeadIds.length} lead${validLeadIds.length > 1 ? "s" : ""} reassigned successfully`,
                    status: "success",
                });
                setIsMultiAssignOpen(false);
                setMultiAssignUserId(null);
                setMultiAssignRemarks("");
                setSelectedLeads([]);
                setSelectAllLeads(false);
                loadMyLeads();
            }
        } catch (error) {
            console.error("Multi reassign error:", error);
        } finally {
            setMultiReassignLoading(false);
        }
    };

    const toggleSelectAllLeads = () => {
        const selectable = getSelectableLeads();
        const selectableIds = selectable.map((lead) => lead.leadId);

        if (selectAllLeads) {
            setSelectedLeads([]);
            setSelectAllLeads(false);
        } else {
            setSelectedLeads(selectableIds);
            setSelectAllLeads(selectableIds.length > 0);
        }
    };

    React.useEffect(() => {
        if (selectionMode === "none") {
            setSelectAllLeads(false);
            return;
        }
        const selectable = getSelectableLeads();
        const selectableIds = selectable.map((lead) => lead.leadId);
        if (selectableIds.length > 0 && selectableIds.every((id) => selectedLeads.includes(id))) {
            setSelectAllLeads(true);
        } else {
            setSelectAllLeads(false);
        }
    }, [selectedLeads, leadData?.leads, selectionMode]);

    const hasSelectableLeads =
        selectionMode === "approval"
            ? leadData.leads?.some((lead) => !lead.isRevoked && lead.isAccepted === null)
            : selectionMode === "reassign"
                ? leadData.leads?.some((lead) => !isLeadWon(lead))
                : false;

    const toggleSelectLead = (leadId: number) => {
        const lead = leadData.leads?.find((l) => l.leadId === leadId);
        if (selectionMode === "reassign" && lead && isLeadWon(lead)) return;
        if (selectionMode === "approval" && lead && (lead.isRevoked || lead.isAccepted !== null)) return;

        setSelectedLeads(prev =>
            prev.includes(leadId)
                ? prev.filter(x => x !== leadId)
                : [...prev, leadId]
        );
    };

    const handleBulkAcceptLead = async () => {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        try {
            setBulkApprovalLoading(true);
            const res = await fetchApi(
                `LeadRequirement/BulkAcceptLead?timeZone=${encodeURIComponent(timezone)}`,
                "PUT",
                { leadIds: selectedLeads, reason: bulkReason }
            );
            if (res) {
                addToast({ message: res.message, status: "success" });
                setSelectedLeads([]);
                setSelectAllLeads(false);
                onBulkApprovalClose();
                loadMyLeads();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setBulkApprovalLoading(false);
        }
    };

    const handleBulkRejectLead = async () => {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        try {
            setBulkApprovalLoading(true);
            const selectedDisqualifyReasonObj = disReasonOptions.find((d) => d.id === bulkDisqualifyReasonId);
            const res = await fetchApi(
                `LeadRequirement/BulkRejectLead?timeZone=${encodeURIComponent(timezone)}`,
                "PUT",
                {
                    leadIds: selectedLeads,
                    reason: bulkReason,
                    disqualifyReasonId: bulkDisqualifyReasonId,
                    disqualifyReason: selectedDisqualifyReasonObj?.name || "",
                    reasonId: bulkDisqualifyReasonId,
                }
            );
            if (res) {
                addToast({ message: res.message, status: "success" });
                setSelectedLeads([]);
                setSelectAllLeads(false);
                setBulkReason("");
                setBulkDisqualifyReasonId(null);
                onBulkApprovalClose();
                loadMyLeads();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setBulkApprovalLoading(false);
        }
    };


    const handleAcceptLead = async () => {
        if (!selectedLead) return;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        try {
            setApprovalLoading(true);
            const res = await fetchApi(`LeadRequirement/AcceptLead?timeZone=${encodeURIComponent(timezone)}`, "PUT", { leadId: selectedLead.leadId, reason: rejectReason, });
            if (res) {
                setSelectedLeads([]);
                setSelectAllLeads(false);
                onApprovalClose();
                setSelectedLead(null);
                setApprovalType(null);
                setRejectReason("");
                setDisqualifyReasonId(null);
                addToast({ message: res.message, status: "success" });
                loadMyLeads();
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setApprovalLoading(false);
        }
    };


    const handleRejectLead = async () => {
        if (!selectedLead) return;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        try {
            setApprovalLoading(true);
            const selectedDisqualifyReasonObj = disReasonOptions.find((d) => d.id === disqualifyReasonId);
            const res = await fetchApi(`LeadRequirement/RejectLead?timeZone=${encodeURIComponent(timezone)}`, "PUT", {
                leadId: selectedLead.leadId,
                reason: rejectReason,
                disqualifyReasonId: disqualifyReasonId,
                disqualifyReason: selectedDisqualifyReasonObj?.name || "",
                reasonId: disqualifyReasonId,
            });
            if (res) {
                setSelectedLeads([]);
                setSelectAllLeads(false);
                onApprovalClose();
                setSelectedLead(null);
                setApprovalType(null);
                setRejectReason("");
                setDisqualifyReasonId(null);
                addToast({ message: res.message, status: "success" });
                loadMyLeads();

            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setApprovalLoading(false);
        }
    };

    const handleOpenRevokeModal = (lead: ILead) => {
        setSelectedLead(lead);
        setRevokeReason("");
        setRevokeError("");
        onRevokeOpen();
    };

    const handleRevokeLead = async () => {
        if (!selectedLead) return;

        const trimmedReason = revokeReason.trim();
        if (!trimmedReason) {
            setRevokeError("Revoke reason is required.");
            return;
        }

        if (trimmedReason.length < 3) {
            setRevokeError("Reason must be between 3 and 2000 characters.");
            return;
        }

        if (trimmedReason.length > 2000) {
            setRevokeError("Reason must be between 3 and 2000 characters.");
            return;
        }

        const leadId = selectedLead.leadId || (selectedLead as any).id;
        if (!leadId) {
            addToast({ message: "Invalid lead ID.", status: "error" });
            return;
        }

        try {
            setRevokeLoading(true);
            setRevokeError("");

            const payload = {
                reason: trimmedReason,
                Reason: trimmedReason,
            };

            const res = await fetchApi(
                `Lead/RevokeLead/${leadId}`,
                "PUT",
                payload
            );

            if (res) {
                addToast({
                    message: res.message || "Lead revoked successfully.",
                    status: "success",
                });
                onRevokeClose();
                setSelectedLead(null);
                setRevokeReason("");
                setRevokeError("");
                await loadMyLeads();
            }
        } catch (error) {
            console.error("Error revoking lead:", error);
        } finally {
            setRevokeLoading(false);
        }
    };

    return (
        <MyDiv>
            <Box>
                <Grid className="grid_container" mt={10}>
                    <GridItem colSpan={12}>

                        {/* Selection Mode Toggle Buttons */}
                        <Flex mb={4} justify="space-between" align="center" wrap="wrap" gap={3}>
                            <Flex align="center" gap={2}>
                                {(canBulkAcceptLead || canBulkRejectLead) && (
                                    <Button
                                        size="sm"
                                        borderRadius="8px"
                                        variant={selectionMode === "approval" ? "solid" : "outline"}
                                        colorScheme="blue"
                                        leftIcon={<CheckIcon />}
                                        onClick={() => {
                                            if (selectionMode === "approval") {
                                                setSelectionMode("none");
                                                setSelectedLeads([]);
                                                setSelectAllLeads(false);
                                            } else {
                                                setSelectionMode("approval");
                                                setSelectedLeads([]);
                                                setSelectAllLeads(false);
                                            }
                                        }}
                                    >
                                        Bulk Approval {selectionMode === "approval" && selectedLeads.length > 0 ? `(${selectedLeads.length})` : ""}
                                    </Button>
                                )}

                                {canReassign && (
                                    <Button
                                        size="sm"
                                        borderRadius="8px"
                                        variant={selectionMode === "reassign" ? "solid" : "outline"}
                                        colorScheme="purple"
                                        leftIcon={<RepeatIcon />}
                                        onClick={() => {
                                            if (selectionMode === "reassign") {
                                                setSelectionMode("none");
                                                setSelectedLeads([]);
                                                setSelectAllLeads(false);
                                            } else {
                                                setSelectionMode("reassign");
                                                setSelectedLeads([]);
                                                setSelectAllLeads(false);
                                                loadTeamUsers();
                                            }
                                        }}
                                    >
                                        Bulk Reassign {selectionMode === "reassign" && selectedLeads.length > 0 ? `(${selectedLeads.length})` : ""}
                                    </Button>
                                )}
                            </Flex>

                            {selectionMode !== "none" && (
                                <Button
                                    size="xs"
                                    variant="ghost"
                                    color="gray.500"
                                    onClick={() => {
                                        setSelectionMode("none");
                                        setSelectedLeads([]);
                                        setSelectAllLeads(false);
                                    }}
                                >
                                    Cancel Selection Mode
                                </Button>
                            )}
                        </Flex>

                        {/* Banner when Approval mode has selection */}
                        {selectionMode === "approval" && selectedLeads.length > 0 && (
                            <Flex mb={4} p={3} bg="blue.50" border="1px solid" borderColor="blue.100" borderRadius="12px"
                                align={{ base: "stretch", md: "center" }} justify="space-between"
                                direction={{ base: "column", md: "row" }} gap={3}
                            >
                                <Flex align="center" gap={3}>
                                    <Box px={3} py={1} borderRadius="full" bg="blue.100" color="blue.700" fontWeight="700" fontSize="sm">
                                        {selectedLeads.length} selected
                                    </Box>
                                    <Text fontSize="sm" color="gray.700" fontWeight="500">
                                        Choose an action for selected pending leads
                                    </Text>
                                </Flex>

                                <Flex gap={2} wrap="wrap">
                                    {canBulkAcceptLead && (
                                        <Button size="sm" colorScheme="blue" variant="solid"
                                            onClick={() => { setBulkApprovalType("accept"); setBulkReason(""); onBulkApprovalOpen(); }}
                                        >
                                            Bulk Accept
                                        </Button>
                                    )}

                                    {canBulkRejectLead && (
                                        <Button size="sm" colorScheme="red" variant="solid"
                                            onClick={() => {
                                                setBulkApprovalType("reject");
                                                setBulkReason("");
                                                setBulkDisqualifyReasonId(null);
                                                loadStatsReasons();
                                                onBulkApprovalOpen();
                                            }}
                                        >
                                            Bulk Reject
                                        </Button>
                                    )}

                                    <Button size="sm" variant="ghost"
                                        onClick={() => { setSelectedLeads([]); setSelectAllLeads(false); }}
                                    >
                                        Clear
                                    </Button>
                                </Flex>
                            </Flex>
                        )}

                        {/* Banner when Reassign mode has selection */}
                        {selectionMode === "reassign" && selectedLeads.length > 0 && (
                            <Flex mb={4} p={3} bg="purple.50" border="1px solid" borderColor="purple.100" borderRadius="12px"
                                align={{ base: "stretch", md: "center" }} justify="space-between"
                                direction={{ base: "column", md: "row" }} gap={3}
                            >
                                <Flex align="center" gap={3}>
                                    <Box px={3} py={1} borderRadius="full" bg="purple.100" color="purple.700" fontWeight="700" fontSize="sm">
                                        {selectedLeads.length} selected
                                    </Box>
                                    <Text fontSize="sm" color="gray.700" fontWeight="500">
                                        Reassign selected leads to another team member
                                    </Text>
                                </Flex>

                                <Flex gap={2} wrap="wrap">
                                    <Button size="sm" colorScheme="purple" variant="solid" leftIcon={<RepeatIcon />}
                                        onClick={() => {
                                            loadTeamUsers();
                                            setIsMultiAssignOpen(true);
                                        }}
                                    >
                                        Reassign ({selectedLeads.length})
                                    </Button>

                                    <Button size="sm" variant="ghost"
                                        onClick={() => { setSelectedLeads([]); setSelectAllLeads(false); }}
                                    >
                                        Clear
                                    </Button>
                                </Flex>
                            </Flex>
                        )}

                        <Box mt={4} overflowX="auto" borderRadius="16px"
                            sx={{ "&::-webkit-scrollbar": { height: "2px", }, }} >



                            <CustomExpandTable autoCloseExpand={true} loading={loading} value={leadData.leads} rowKey="leadId" emptyMessage="No Leads Found"
                                getRowBgColor={(row: any) => row.isAccepted === false ? "#FFECEC" : row.isAccepted === null ? "#FFF4E5" : undefined}
                                renderExpandedContent={(row: any) => (

                                    <Box p={4}>
                                        {expandType?.leadId === row.leadId &&
                                            expandType?.type === "meeting" ? (
                                            <MeetingFormTab
                                                leadId={row.leadId}
                                                pocEmail={row.email}
                                                onMeetingSaved={onMeetingRefresh}
                                            />
                                        ) : expandType?.leadId === row.leadId &&
                                            expandType?.type === "followup" ? (
                                            <FollowUpFormTab leadId={row.leadId} onFollowUpSaved={onFollowUpRefresh} />
                                        ) : expandType?.leadId === row.leadId &&
                                            expandType?.type === "message" ? (
                                            <SendMessageForm
                                                leadId={row.leadId}
                                                pocName={row.pocName}
                                                pocEmail={row.email}
                                                onMessageSaved={onMessageRefresh}
                                            />
                                        ) : (
                                            <LeadRequirement
                                                leadId={row.leadId}
                                                leadData={row}
                                                onClose={row.closeExpand}
                                            />
                                        )}
                                    </Box>
                                )}
                            >
                                {selectionMode !== "none" && (
                                    <Column
                                        header={
                                            <Checkbox
                                                isChecked={selectAllLeads}
                                                isDisabled={!hasSelectableLeads}
                                                onChange={toggleSelectAllLeads}
                                            />
                                        }
                                        body={(row: any) => {
                                            const isRowDisabled =
                                                selectionMode === "approval"
                                                    ? (row.isRevoked || row.isAccepted !== null)
                                                    : selectionMode === "reassign"
                                                        ? isLeadWon(row)
                                                        : false;
                                            return (
                                                <Checkbox
                                                    isDisabled={isRowDisabled}
                                                    cursor={isRowDisabled ? "not-allowed" : "pointer"}
                                                    isChecked={selectedLeads.includes(row.leadId)}
                                                    onChange={() => {
                                                        if (isRowDisabled) return;
                                                        toggleSelectLead(row.leadId);
                                                        if (selectionMode === "reassign" && userOptions.length === 0) {
                                                            loadTeamUsers();
                                                        }
                                                    }}
                                                />
                                            );
                                        }}
                                    />
                                )}
                                {/* <Column header="S.No" body={(_, index) => index + 1} /> */}
                                {/* <Column header="Lead ID" field="leadId" /> */}
                                <Column
                                    header="S.No"
                                    body={(_, index) => first + index + 1}
                                />

                                <Column
                                    header="Company"
                                    body={(row: any, index: number) => {
                                        const blinkClass =
                                            row.isToday15MinLeft
                                                ? "blink-red"
                                                : row.isTodayMeeting
                                                    ? "blink-orange"
                                                    : "";

                                        return (
                                            <Tooltip
                                                label={getDisplayValue(row.companyName, "company", index)}
                                                hasArrow placement="top" >
                                                <Box color={
                                                    canNavigateLeadDetail
                                                        ? "#2563EB"
                                                        : "#101828"
                                                } maxW="200px" isTruncated cursor={canNavigateLeadDetail ? "pointer" : "default"}
                                                    onClick={() => {
                                                        if (canNavigateLeadDetail) {
                                                            NavigateLeadDetail(row);
                                                        }
                                                    }}>
                                                    <RevealField
                                                        rowIndex={index}
                                                        field="company"
                                                        value={row.companyName}
                                                        className={blinkClass}
                                                    />
                                                </Box>
                                            </Tooltip>
                                        );
                                    }}
                                />


                                <Column
                                    header="POC"
                                    body={(row: any, index: number) => (
                                        <Tooltip label={getDisplayValue(row.pocName, "poc", index)} hasArrow placement="top">
                                            <Box color={
                                                canNavigateLeadDetail
                                                    ? "#2563EB"
                                                    : "#101828"
                                            } maxW="180px" isTruncated cursor={canNavigateLeadDetail ? "pointer" : "default"} onClick={() => {
                                                if (canNavigateLeadDetail) {
                                                    NavigateLeadDetail(row);
                                                }
                                            }}>
                                                <RevealField rowIndex={index} field="poc" value={row.pocName} />
                                            </Box>
                                        </Tooltip>
                                    )}

                                />

                                <Column
                                    header="Contact"
                                    body={(row: any, index: number) => (
                                        <Box
                                            color={canNavigateLeadDetail ? "#2563EB" : "#101828"}
                                            cursor={canNavigateLeadDetail ? "pointer" : "default"}
                                            onClick={() => {
                                                if (canNavigateLeadDetail) {
                                                    NavigateLeadDetail(row);
                                                }
                                            }}
                                        >
                                            <RevealField
                                                rowIndex={index}
                                                field="contact"
                                                value={
                                                    row.countryCode
                                                        ? `${row.countryCode} ${row.contact}`
                                                        : row.contact
                                                }
                                            />
                                        </Box>
                                    )}
                                />

                                <Column
                                    header="Email"
                                    body={(row: any, index: number) => (
                                        <Box color={
                                            canNavigateLeadDetail
                                                ? "#2563EB"
                                                : "#101828"
                                        } cursor={canNavigateLeadDetail ? "pointer" : "default"} onClick={() => {
                                            if (canNavigateLeadDetail) {
                                                NavigateLeadDetail(row);
                                            }
                                        }} >
                                            <RevealField rowIndex={index} field="email" value={row.email} />
                                        </Box>
                                    )}
                                />
                                <Column
                                    header="Website"
                                    body={(row: any, index: number) => {
                                        const canOpenWebsite =
                                            row.isAccepted ||
                                            hasPermission("LeadPool", "View Website Before Accept");

                                        return (
                                            <RevealField
                                                rowIndex={index}
                                                field="websiteUrl"
                                                value={row.websiteUrl}
                                            >
                                                {row.websiteUrl ? (
                                                    canOpenWebsite ? (
                                                        <Link
                                                            href={
                                                                row.websiteUrl.startsWith("http")
                                                                    ? row.websiteUrl
                                                                    : `https://${row.websiteUrl}`
                                                            }
                                                            isExternal
                                                            color="#2563EB"
                                                            textDecoration="underline"
                                                            maxW="180px"
                                                            display="block"
                                                            whiteSpace="nowrap"
                                                            overflow="hidden"
                                                            textOverflow="ellipsis"
                                                        >
                                                            {row.websiteUrl}
                                                        </Link>
                                                    ) : (
                                                        <Text
                                                            maxW="180px"
                                                            whiteSpace="nowrap"
                                                            overflow="hidden"
                                                            textOverflow="ellipsis"
                                                        >
                                                            {row.websiteUrl}
                                                        </Text>
                                                    )
                                                ) : (
                                                    <Text>N/A</Text>
                                                )}
                                            </RevealField>
                                        );
                                    }}
                                />
                                <Column header="Country" field="countryName" textAlign="center" />

                                <Column header="Assigned To" field="assignedToUser" />

                                <Column
                                    header="Lead Status"
                                    body={(row: any) => {
                                        const isRevoked = Boolean(row.isRevoked);
                                        const statusStyle = isRevoked
                                            ? { bg: "#F3E8FF", color: "#7E22CE" }
                                            : getStatusStyle(row.leadStatus);
                                        const isPending = !isRevoked && row.isAccepted === null;
                                        const isAccepted = !isRevoked && row.isAccepted === true;
                                        const isRejected = !isRevoked && row.isAccepted === false;
                                        const isFinalStatus =
                                            row.leadStatus === "Won" ||
                                            row.leadStatus === "Lost" ||
                                            row.leadStatus === "Rejected";
                                        const canChangeLeadStatus = canUpdateStatus && isAccepted && !isFinalStatus && !isRevoked;
                                        return (
                                            <Box display="inline-flex" alignItems="center" bg={statusStyle.bg} color={statusStyle.color} px="12px" py="6px" borderRadius="20px" fontSize="13px" fontWeight="500" gap="6px"
                                                cursor={canChangeLeadStatus ? "pointer" : "not-allowed"}
                                                opacity={canChangeLeadStatus ? 1 : 0.6}
                                                onClick={() => {
                                                    if (!canUpdateStatus) return;
                                                    if (isRevoked) {
                                                        addToast({
                                                            message: "Cannot change status of a revoked lead.",
                                                            status: "warning",
                                                        });
                                                        return;
                                                    }
                                                    if (row.isAccepted === null) {
                                                        addToast({
                                                            message: "Please accept the lead before changing its status.",
                                                            status: "warning",
                                                        });
                                                        return;
                                                    }
                                                    if (row.isAccepted === false) {
                                                        addToast({
                                                            message: "You have rejected this lead. Status cannot be changed.",
                                                            status: "error",
                                                        });
                                                        return;
                                                    }

                                                    if (!canChangeLeadStatus) return;

                                                    handleOpenStatusModal(row);
                                                }}
                                            >
                                                <Text m={0}>
                                                    {isRevoked ? "Revoked" : (row.leadStatus || "Lead Created")}
                                                </Text>

                                                {canChangeLeadStatus && (
                                                    <Image src={ArrowIcon} boxSize="6px" />
                                                )}
                                            </Box>
                                        );
                                    }}
                                />

                                <Column
                                    header="Created At"
                                    body={(row: any) => row.createdAt ? showDateTime(row.createdAt) : "N/A"}
                                />
                                <Column header="Created By" field="createdBy" />


                                <Column
                                    header="Action"
                                    body={(row: any) => {
                                        const isRevoked = Boolean(row.isRevoked);
                                        const isPending = !isRevoked && row.isAccepted === null;
                                        const isAccepted = !isRevoked && row.isAccepted === true;
                                        const isRejected = !isRevoked && row.isAccepted === false;
                                        const isBdm = row.isBdm;
                                        const isPreSales = row.isPreSales;
                                        const hasBothRoles = isBdm && isPreSales;
                                        const showAcceptedActions =
                                            !isRevoked && (
                                                hasBothRoles
                                                    ? isAccepted === true
                                                    : isPreSales || (isBdm && isAccepted === true)
                                            );
                                        const isEligibleForRevoke = canRevokeLead && !isRevoked && !isLeadWon(row) && row.isAccepted !== null;
                                        return (
                                            <Flex align="center" gap={2} wrap="nowrap" width="max-content" >

                                                {/* Revoked Status Display */}
                                                {isRevoked && (
                                                    <Tooltip
                                                        label={`Revoked${row.revokeReason ? `: ${row.revokeReason}` : (row.reason ? `: ${row.reason}` : "")}${row.revokedAt ? ` on ${showDateTime(row.revokedAt)}` : ""}`}
                                                        hasArrow
                                                    >
                                                        <Flex
                                                            align="center"
                                                            gap={1}
                                                            px={2.5}
                                                            py={1}
                                                            borderRadius="full"
                                                            bg="purple.50"
                                                            color="purple.700"
                                                            border="1px solid"
                                                            borderColor="purple.200"
                                                            fontSize="12px"
                                                            fontWeight="600"
                                                            cursor={canViewLeadAcceptanceHistory ? "pointer" : "default"}
                                                            _hover={canViewLeadAcceptanceHistory ? { bg: "purple.100" } : undefined}
                                                            onClick={() => canViewLeadAcceptanceHistory && NavigateLeadAssesment(row)}
                                                        >
                                                            <RepeatIcon boxSize={3} color="purple.600" />
                                                            <Text>Revoked</Text>
                                                        </Flex>
                                                    </Tooltip>
                                                )}

                                                {isPending && isBdm && (
                                                    <>
                                                        {canAcceptLead && (
                                                            <Tooltip label="Accept Lead">
                                                                <Flex align="center" justify="center" w="28px" h="28px"
                                                                    borderRadius="full" bg="green.50" cursor="pointer"
                                                                    _hover={{ bg: "green.100" }}
                                                                    onClick={() => {
                                                                        setSelectedLead(row);
                                                                        setApprovalType("accept");
                                                                        setRejectReason("");
                                                                        onApprovalOpen();
                                                                    }}
                                                                >
                                                                    <CheckIcon color="green.500" boxSize={4} />
                                                                </Flex>
                                                            </Tooltip>
                                                        )}

                                                        {canRejectLead && (
                                                            <Tooltip label="Reject Lead">
                                                                <Flex align="center" justify="center" w="28px" h="28px"
                                                                    borderRadius="full" bg="red.50" cursor="pointer"
                                                                    _hover={{ bg: "red.100" }}
                                                                    onClick={() => {
                                                                        setSelectedLead(row);
                                                                        setApprovalType("reject");
                                                                        setRejectReason("");
                                                                        setDisqualifyReasonId(null);
                                                                        loadStatsReasons();
                                                                        onApprovalOpen();
                                                                    }}
                                                                >
                                                                    <CloseIcon color="red.500" boxSize={3} />
                                                                </Flex>
                                                            </Tooltip>
                                                        )}
                                                    </>
                                                )}

                                                {showAcceptedActions && (
                                                    <>

                                                        {row.isAccepted === true && (
                                                            <Tooltip label={`Accepted: ${row.reason ? ` ${row.reason}` : ""}`}>
                                                                <Flex align="center" justify="center" w="24px" h="24px"
                                                                    borderRadius="full" bg="green.500" color="white"
                                                                    cursor={canViewLeadAcceptanceHistory ? "pointer" : "default"}
                                                                    _hover={canViewLeadAcceptanceHistory ? { opacity: 0.8 } : undefined}
                                                                >
                                                                    <CheckIcon boxSize={3} />
                                                                </Flex>
                                                            </Tooltip>
                                                        )}

                                                        {row.isAccepted === null && (
                                                            <Tooltip label="Pending Lead Acceptance">
                                                                <Flex align="center" justify="center" w="24px" h="24px"
                                                                    borderRadius="full" bg="orange.400" color="white"
                                                                    cursor={canViewLeadAcceptanceHistory ? "pointer" : "default"}
                                                                    _hover={canViewLeadAcceptanceHistory ? { opacity: 0.8 } : undefined}
                                                                >
                                                                    <TimeIcon boxSize={3} />
                                                                </Flex>
                                                            </Tooltip>
                                                        )}

                                                        {row.isAccepted === false && (
                                                            <>
                                                                <Tooltip label={`Rejected${(row.disReason || row.disqualifyReason) ? ` [${row.disReason || row.disqualifyReason}]` : ""}${row.reason ? `: ${row.reason}` : ""}`} hasArrow>
                                                                    <Flex align="center" justify="center" w="24px" h="24px"
                                                                        borderRadius="full" bg="red.500" color="white"
                                                                        cursor={canViewLeadAcceptanceHistory ? "pointer" : "default"}
                                                                        _hover={canViewLeadAcceptanceHistory ? { opacity: 0.8 } : undefined}
                                                                    >
                                                                        <CloseIcon boxSize={3} />
                                                                    </Flex>
                                                                </Tooltip>
                                                                {(row.disReason || row.disqualifyReason) && (
                                                                    <Tooltip label={`Disqualify Reason: ${row.disReason || row.disqualifyReason}`} hasArrow>
                                                                        <Flex align="center" px={2.5} py={1} borderRadius="full" bg="orange.50"
                                                                            color="orange.700" border="1px solid" borderColor="orange.200" fontSize="12px"
                                                                            fontWeight="500" maxW="140px"
                                                                        >
                                                                            <Text isTruncated>{row.disReason || row.disqualifyReason}</Text>
                                                                        </Flex>
                                                                    </Tooltip>
                                                                )}
                                                            </>
                                                        )}


                                                        <Tooltip label="Meetings">
                                                            <Flex align="center" justify="center" minW="22px" h="22px" px="1" borderRadius="full" bg="#EFF8FF" color="#175CD3" fontSize="11px" fontWeight="600" cursor="pointer"
                                                                onClick={() => {
                                                                    if (!canViewMeetings) return;

                                                                    setExpandType({
                                                                        leadId: row.leadId,
                                                                        type: "meeting"
                                                                    });

                                                                    row.expandRow();
                                                                }}
                                                            >
                                                                M {row.upcomingMeetingCount || 0}
                                                            </Flex>
                                                        </Tooltip>

                                                        <Tooltip label=" Reminders">
                                                            <Flex align="center" justify="center" minW="22px" h="22px" px="1" borderRadius="full" bg="#ECFDF3" color="#027A48" fontSize="11px" fontWeight="600" cursor="pointer"
                                                                onClick={() => {
                                                                    if (!canViewFollowUps) return;
                                                                    setExpandType({ leadId: row.leadId, type: "followup" });
                                                                    row.expandRow();
                                                                }}                                                    >
                                                                R {row.upcomingFollowupCount || 0}
                                                            </Flex>
                                                        </Tooltip>
                                                        <Tooltip label=" Mail">
                                                            <Flex align="center" justify="center" minW="22px" h="22px" px="1" borderRadius="full" bg="#ECFDF3" color="#027A48" fontSize="11px" fontWeight="600" cursor="pointer"
                                                                onClick={() => {
                                                                    if (!canViewMessages) return;
                                                                    setExpandType({ leadId: row.leadId, type: "message" });
                                                                    row.expandRow();
                                                                }}                                                    >
                                                                M {row.mailCount || 0}
                                                            </Flex>
                                                        </Tooltip>

                                                        {/* Revoke button for eligible accepted leads */}
                                                        {isEligibleForRevoke  && (
                                                            <Tooltip label="Revoke Lead" hasArrow>
                                                                <Button
                                                                    size="xs"
                                                                    colorScheme="red"
                                                                    variant="outline"
                                                                    borderRadius="full"
                                                                    fontSize="11px"
                                                                    fontWeight="500"
                                                                    h="26px"
                                                                    px={2.5}
                                                                    _hover={{ bg: "red.50" }}
                                                                    onClick={() => handleOpenRevokeModal(row)}
                                                                >
                                                                    Revoke
                                                                </Button>
                                                            </Tooltip>
                                                        )}

                                                        <Menu placement="bottom-end" >
                                                            <MenuButton as={IconButton} aria-label="Options" icon={<HamburgerIcon />} variant="ghost" size="sm" />

                                                            {row.isAccepted !== null && (
                                                                <MenuList maxH="180px" overflowY="auto">
                                                                    {row.isAccepted === true && (
                                                                        <MenuItem onClick={() => NavigateMyLeadEdit(row)}>
                                                                            <Flex align="center" gap={2}>
                                                                                <Image src={EditIconn} boxSize="16px" />
                                                                                Edit
                                                                            </Flex>
                                                                        </MenuItem>
                                                                    )}

                                                                    {canViewHistory && (
                                                                        <MenuItem onClick={() => handleHistoryLead(row)}>
                                                                            <Flex align="center" gap={2}>
                                                                                <Image src={HistoryIcon} boxSize="16px" />
                                                                                History
                                                                            </Flex>
                                                                        </MenuItem>
                                                                    )}

                                                                    {canViewRequirementGathering && row.leadStatus === "Requirement Gathering" && (
                                                                        <MenuItem onClick={() => { setExpandType({ leadId: row.leadId, type: "requirement", }); row.expandRow(); }}>
                                                                            <Flex align="center" gap={2}>
                                                                                <Image src={UserIcon} boxSize="16px" />
                                                                                Requirement Gathering
                                                                            </Flex>
                                                                        </MenuItem>
                                                                    )}

                                                                    {row.isAccepted === true && canViewMeetings && (<MenuItem
                                                                        onClick={() => {
                                                                            setExpandType({ leadId: row.leadId, type: "meeting", });
                                                                            row.expandRow();
                                                                        }}
                                                                    > <Flex align="center" gap={2}>
                                                                            <Image src={MeetingIcon} boxSize="16px" />
                                                                            Meeting
                                                                        </Flex>
                                                                    </MenuItem>)}

                                                                    {row.isAccepted === true && canViewFollowUps && (<MenuItem
                                                                        onClick={() => {
                                                                            setExpandType({ leadId: row.leadId, type: "followup", });
                                                                            row.expandRow();
                                                                        }}
                                                                    >
                                                                        <Flex align="center" gap={2}>
                                                                            <Image src={FollowupIcon} boxSize="16px" />
                                                                            Reminder
                                                                        </Flex>
                                                                    </MenuItem>)}

                                                                    {row.isAccepted === true && canViewMessages && (
                                                                        <MenuItem
                                                                            onClick={() => {
                                                                                setExpandType({ leadId: row.leadId, type: "message", });
                                                                                row.expandRow();
                                                                            }}
                                                                        >
                                                                            <Flex align="center" gap={2}>
                                                                                <Image src={SendMessageIcon} boxSize="16px" />
                                                                                Send Email
                                                                            </Flex>
                                                                        </MenuItem>
                                                                    )}
                                                                    {canViewLeadDetail && (
                                                                        <MenuItem onClick={() => NavigateLeadDetail(row)}>
                                                                            <Flex align="center" gap={2}>
                                                                                <ViewIcon />
                                                                                View Details
                                                                            </Flex>
                                                                        </MenuItem>
                                                                    )}
                                                                    {canViewLeadAcceptanceHistory && (
                                                                        <MenuItem onClick={() => NavigateLeadAssesment(row)}>
                                                                            <Flex align="center" gap={2}>
                                                                                <Image src={HistoryIcon} boxSize="16px" />
                                                                                Lead Acceptance History
                                                                            </Flex>
                                                                        </MenuItem>
                                                                    )}

                                                                    {isEligibleForRevoke  && (
                                                                        <MenuItem onClick={() => handleOpenRevokeModal(row)}>
                                                                            <Flex align="center" gap={2} color="red.600">
                                                                                <RepeatIcon boxSize="14px" />
                                                                                Revoke
                                                                            </Flex>
                                                                        </MenuItem>
                                                                    )}
                                                                </MenuList>
                                                            )}
                                                        </Menu>

                                                    </>
                                                )}

                                                {/* Revoked Lead Menu */}
                                                {isRevoked && (
                                                    <Menu placement="bottom-end">
                                                        <MenuButton as={IconButton} aria-label="Options" icon={<HamburgerIcon />} variant="ghost" size="sm" />
                                                        <MenuList maxH="150px" overflowY="auto">
                                                            {canViewHistory && (
                                                                <MenuItem onClick={() => handleHistoryLead(row)}>
                                                                    <Flex align="center" gap={2}>
                                                                        <Image src={HistoryIcon} boxSize="16px" />
                                                                        History
                                                                    </Flex>
                                                                </MenuItem>
                                                            )}
                                                            {canViewLeadDetail && (
                                                                <MenuItem onClick={() => NavigateLeadDetail(row)}>
                                                                    <Flex align="center" gap={2}>
                                                                        <ViewIcon />
                                                                        View Details
                                                                    </Flex>
                                                                </MenuItem>
                                                            )}
                                                            {canViewLeadAcceptanceHistory && (
                                                                <MenuItem onClick={() => NavigateLeadAssesment(row)}>
                                                                    <Flex align="center" gap={2}>
                                                                        <Image src={HistoryIcon} boxSize="16px" />
                                                                        Lead Acceptance History
                                                                    </Flex>
                                                                </MenuItem>
                                                            )}
                                                        </MenuList>
                                                    </Menu>
                                                )}

                                                {isRejected && isBdm && (
                                                    <>
                                                        <Tooltip label={`Rejected${(row.disReason || row.disqualifyReason) ? ` [${row.disReason || row.disqualifyReason}]` : ""}${row.reason ? `: ${row.reason}` : ""}`} hasArrow>
                                                            <Flex align="center" gap={1} px={3} py={1} borderRadius="full" bg="red.50"
                                                                color="red.600" border="1px solid" borderColor="red.200" fontSize="12px"
                                                                fontWeight="600"
                                                                cursor={canViewLeadAcceptanceHistory ? "pointer" : "default"}
                                                                _hover={canViewLeadAcceptanceHistory ? { bg: "red.100" } : undefined}
                                                                onClick={() => canViewLeadAcceptanceHistory && NavigateLeadAssesment(row)}
                                                            >
                                                                <CloseIcon boxSize={2.5} />
                                                                <Text>Rejected</Text>
                                                            </Flex>
                                                        </Tooltip>
                                                        {(row.disReason || row.disqualifyReason) && (
                                                            <Tooltip label={`Disqualify Reason: ${row.disReason || row.disqualifyReason}`} hasArrow>
                                                                <Flex align="center" px={2.5} py={1} borderRadius="full" bg="orange.50"
                                                                    color="orange.700" border="1px solid" borderColor="orange.200" fontSize="12px"
                                                                    fontWeight="500" maxW="140px"
                                                                >
                                                                    <Text isTruncated>{row.disReason || row.disqualifyReason}</Text>
                                                                </Flex>
                                                            </Tooltip>
                                                        )}

                                                        {/* Revoke button for eligible rejected leads */}
                                                        {isEligibleForRevoke && (
                                                            <Tooltip label="Revoke Lead" hasArrow>
                                                                <Button
                                                                    size="xs"
                                                                    colorScheme="red"
                                                                    variant="outline"
                                                                    borderRadius="full"
                                                                    fontSize="11px"
                                                                    fontWeight="500"
                                                                    h="26px"
                                                                    px={2.5}
                                                                    _hover={{ bg: "red.50" }}
                                                                    onClick={() => handleOpenRevokeModal(row)}
                                                                >
                                                                    Revoke
                                                                </Button>
                                                            </Tooltip>
                                                        )}

                                                        <Menu placement="bottom-end">
                                                            <MenuButton as={IconButton} aria-label="Options" icon={<HamburgerIcon />} variant="ghost" size="sm" />
                                                            <MenuList maxH="180px" overflowY="auto">
                                                                {canViewHistory && (
                                                                    <MenuItem onClick={() => handleHistoryLead(row)}>
                                                                        <Flex align="center" gap={2}>
                                                                            <Image src={HistoryIcon} boxSize="16px" />
                                                                            History
                                                                        </Flex>
                                                                    </MenuItem>
                                                                )}
                                                                {canViewLeadDetail && (
                                                                    <MenuItem onClick={() => NavigateLeadDetail(row)}>
                                                                        <Flex align="center" gap={2}>
                                                                            <ViewIcon />
                                                                            View Details
                                                                        </Flex>
                                                                    </MenuItem>
                                                                )}
                                                                {canViewLeadAcceptanceHistory && (
                                                                    <MenuItem onClick={() => NavigateLeadAssesment(row)}>
                                                                        <Flex align="center" gap={2}>
                                                                            <Image src={HistoryIcon} boxSize="16px" />
                                                                            Lead Acceptance History
                                                                        </Flex>
                                                                    </MenuItem>
                                                                )}
                                                                {isEligibleForRevoke && (
                                                                    <MenuItem onClick={() => handleOpenRevokeModal(row)}>
                                                                        <Flex align="center" gap={2} color="red.600">
                                                                            <RepeatIcon boxSize="14px" />
                                                                            Revoke
                                                                        </Flex>
                                                                    </MenuItem>
                                                                )}
                                                            </MenuList>
                                                        </Menu>
                                                    </>
                                                )}

                                                {canViewNotesAndResponse && (
                                                    <Tooltip
                                                        hasArrow
                                                        placement="top"
                                                        label={
                                                            row.notesResponse?.trim()
                                                                ? "View Notes & Response"
                                                                : "Notes & Response not available"
                                                        }
                                                    >
                                                        <Flex
                                                            align="center"
                                                            justify="center"
                                                            w="24px"
                                                            h="24px"
                                                            borderRadius="full"
                                                            bg="blue.50"
                                                            color="blue.600"
                                                            cursor="pointer"
                                                            _hover={{ bg: "blue.100" }}
                                                            onClick={() => {
                                                                if (row.notesResponse?.trim()) {
                                                                    setSelectedNotesResponse(row.notesResponse);
                                                                    onNotesModalOpen();
                                                                } else {
                                                                    addToast({
                                                                        message: "Notes & Response not available",
                                                                        status: "warning",
                                                                    });
                                                                }
                                                            }}
                                                        >
                                                            <ViewIcon boxSize={4} />
                                                        </Flex>
                                                    </Tooltip>
                                                )}
                                            </Flex>
                                        )
                                    }
                                    }
                                />
                            </CustomExpandTable>

                        </Box>
                        <Modal isOpen={isApprovalOpen} onClose={() => { if (!approvalLoading) { onApprovalClose(); setRejectReason(""); setDisqualifyReasonId(null); } }} isCentered >
                            <ModalOverlay />
                            <ModalContent>
                                <ModalHeader> {approvalType === "accept" ? "Accept Lead" : "Reject Lead"} </ModalHeader>
                                <ModalCloseButton isDisabled={approvalLoading} />
                                <ModalBody>
                                    <Text mb={3}>
                                        {approvalType === "accept"
                                            ? "Are you sure you want to accept this lead?"
                                            : "Please select a disqualify reason and enter rejection remarks for this lead."}
                                    </Text>

                                    {approvalType === "reject" && (
                                        <Box mb={4}>
                                            <Text fontSize="14px" fontWeight="500" mb={2}>
                                                Disqualify Reason <Text as="span" color="red.500">*</Text>
                                            </Text>
                                            <Select
                                                placeholder="Select Disqualify Reason"
                                                value={disqualifyReasonId ?? ""}
                                                onChange={(e) => setDisqualifyReasonId(e.target.value ? Number(e.target.value) : null)}
                                                borderRadius="8px"
                                                fontSize="13px"
                                            >
                                                {disReasonOptions.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </Select>
                                        </Box>
                                    )}

                                    <Box mb={2}>
                                        <Text fontSize="14px" fontWeight="500" mb={2}>
                                            {approvalType === "accept" ? "Reason (Optional)" : "Reason / Remarks"}
                                        </Text>
                                        <Textarea
                                            placeholder={
                                                approvalType === "accept"
                                                    ? "Reason for accepting the lead (Optional)"
                                                    : "Reason for rejecting the lead"
                                            }
                                            value={rejectReason}
                                            onChange={(e) => setRejectReason(e.target.value)}
                                            borderRadius="8px"
                                            fontSize="13px"
                                            rows={3}
                                        />
                                    </Box>

                                    {approvalType === "reject" &&
                                        rejectReason.trim().length > 0 &&
                                        rejectReason.trim().length < 20 && (
                                            <Text color="red.500" fontSize="sm" mt={1}>
                                                Reason must be at least 20 characters long.
                                            </Text>
                                        )}
                                </ModalBody>
                                <ModalFooter>
                                    <Button
                                        variant="ghost"
                                        mr={3}
                                        onClick={() => {
                                            onApprovalClose();
                                            setRejectReason("");
                                            setDisqualifyReasonId(null);
                                        }}
                                        isDisabled={approvalLoading}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        colorScheme={approvalType === "accept" ? "green" : "red"}
                                        onClick={() => {
                                            if (approvalType === "accept") {
                                                handleAcceptLead();
                                            } else {
                                                handleRejectLead();
                                            }
                                        }}
                                        isLoading={approvalLoading}
                                        loadingText={approvalType === "accept" ? "Accepting..." : "Rejecting..."}
                                        isDisabled={
                                            approvalLoading ||
                                            (approvalType === "reject" && (!disqualifyReasonId || rejectReason.trim().length < 20))
                                        }
                                    >
                                        {approvalType === "accept" ? "Accept" : "Reject"}
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </Modal>


                        <Modal isOpen={isBulkApprovalOpen} onClose={bulkApprovalLoading ? () => { } : () => { onBulkApprovalClose(); setBulkReason(""); setBulkDisqualifyReasonId(null); }} isCentered >
                            <ModalOverlay />

                            <ModalContent>
                                <ModalHeader>
                                    {bulkApprovalType === "accept" ? "Bulk Accept Leads" : "Bulk Reject Leads"}
                                </ModalHeader>
                                <ModalCloseButton isDisabled={bulkApprovalLoading} />

                                <ModalBody>
                                    <Text mb={3}>
                                        {bulkApprovalType === "accept"
                                            ? `Are you sure you want to accept ${selectedLeads.length} selected leads?`
                                            : `Please select a disqualify reason and enter rejection remarks for ${selectedLeads.length} selected leads.`}
                                    </Text>

                                    {bulkApprovalType === "reject" && (
                                        <Box mb={4}>
                                            <Text fontSize="14px" fontWeight="500" mb={2}>
                                                Disqualify Reason <Text as="span" color="red.500">*</Text>
                                            </Text>
                                            <Select
                                                placeholder="Select Disqualify Reason"
                                                value={bulkDisqualifyReasonId ?? ""}
                                                onChange={(e) => setBulkDisqualifyReasonId(e.target.value ? Number(e.target.value) : null)}
                                                borderRadius="8px"
                                                fontSize="13px"
                                            >
                                                {disReasonOptions.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </Select>
                                        </Box>
                                    )}

                                    <Box mb={2}>
                                        <Text fontSize="14px" fontWeight="500" mb={2}>
                                            {bulkApprovalType === "accept" ? "Reason (Optional)" : "Reason / Remarks"}
                                        </Text>
                                        <Textarea
                                            placeholder={
                                                bulkApprovalType === "accept"
                                                    ? "Reason (Optional)"
                                                    : "Reason for rejection"
                                            }
                                            value={bulkReason}
                                            onChange={(e) => setBulkReason(e.target.value)}
                                            borderRadius="8px"
                                            fontSize="13px"
                                            rows={3}
                                        />
                                    </Box>

                                    {bulkApprovalType === "reject" &&
                                        bulkReason.trim().length > 0 &&
                                        bulkReason.trim().length < 20 && (
                                            <Text color="red.500" fontSize="sm" mt={1}>
                                                Reason must be at least 20 characters long.
                                            </Text>
                                        )}
                                </ModalBody>

                                <ModalFooter>
                                    <Button
                                        mr={3}
                                        onClick={() => {
                                            onBulkApprovalClose();
                                            setBulkReason("");
                                            setBulkDisqualifyReasonId(null);
                                        }}
                                        isDisabled={bulkApprovalLoading}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        colorScheme={bulkApprovalType === "accept" ? "green" : "red"}
                                        onClick={() =>
                                            bulkApprovalType === "accept"
                                                ? handleBulkAcceptLead()
                                                : handleBulkRejectLead()
                                        }
                                        isLoading={bulkApprovalLoading}
                                        loadingText={bulkApprovalType === "accept" ? "Accepting..." : "Rejecting..."}
                                        isDisabled={
                                            bulkApprovalLoading ||
                                            (bulkApprovalType === "reject" && (!bulkDisqualifyReasonId || bulkReason.trim().length < 20))
                                        }
                                    >
                                        {bulkApprovalType === "accept" ? "Bulk Accept" : "Bulk Reject"}
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </Modal>


                        <Modal isOpen={isNotesModalOpen} onClose={onNotesModalClose} isCentered size="xl">
                            <ModalOverlay />
                            <ModalContent borderRadius="12px">
                                <ModalHeader borderBottom="1px solid" borderColor="gray.100" py={4} pr={10}>
                                    Notes & Response
                                </ModalHeader>
                                <ModalCloseButton />
                                <ModalBody py={6}>
                                    <Box
                                        maxH="450px"
                                        overflowY="auto"
                                        pr={2}
                                        className="notes-response-content"
                                        dangerouslySetInnerHTML={{ __html: selectedNotesResponse }}
                                    />
                                </ModalBody>
                                <ModalFooter borderTop="1px solid" borderColor="gray.100" py={3}>
                                    <Button colorScheme="blue" onClick={onNotesModalClose}>
                                        Close
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </Modal>
                        {/* Multi Assign / Reassign Modal */}
                        <Modal
                            isOpen={isMultiAssignOpen}
                            onClose={() => { if (!multiReassignLoading) { setIsMultiAssignOpen(false); setMultiAssignRemarks(""); } }}
                            closeOnOverlayClick={!multiReassignLoading}
                            isCentered
                        >
                            <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(4px)" />
                            <ModalContent borderRadius="12px" maxW="380px">
                                <ModalHeader fontSize="16px">Reassign Leads</ModalHeader>
                                <ModalCloseButton isDisabled={multiReassignLoading} />

                                <ModalBody>
                                    <Box mb={4} p={3} bg="#F9FAFB" borderRadius="8px" border="1px solid #E4E7EC">
                                        <Text fontSize="12px" color="#667085" mb={1}>
                                            Selected Leads
                                        </Text>
                                        <Text fontSize="13px" fontWeight="600" color="#344054">
                                            {selectedLeads.length} Lead{selectedLeads.length > 1 ? "s" : ""} will be reassigned
                                        </Text>
                                    </Box>

                                    <Box mb={4}>
                                        <Text fontSize="14px" fontWeight="500" mb={2}>
                                            Assign To
                                        </Text>
                                        <Select
                                            value={multiAssignUserId ?? ""}
                                            placeholder="Select team member"
                                            borderRadius="8px"
                                            fontSize="13px"
                                            onChange={(e) => setMultiAssignUserId(Number(e.target.value))}
                                        >
                                            {userOptions.map((user) => (
                                                <option key={user.id} value={user.id}>
                                                    {user.name}
                                                </option>
                                            ))}
                                        </Select>
                                    </Box>

                                    <Box mb={2}>
                                        <Text fontSize="14px" fontWeight="500" mb={2}>
                                            Description / Remarks
                                        </Text>
                                        <Textarea
                                            value={multiAssignRemarks}
                                            onChange={(e) => setMultiAssignRemarks(e.target.value)}
                                            placeholder="Enter description or remarks..."
                                            borderRadius="8px"
                                            fontSize="13px"
                                            rows={3}
                                        />
                                    </Box>
                                </ModalBody>

                                <ModalFooter gap={3}>
                                    <Button
                                        variant="ghost"
                                        onClick={() => { setIsMultiAssignOpen(false); setMultiAssignRemarks(""); }}
                                        isDisabled={multiReassignLoading}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        colorScheme="purple"
                                        onClick={handleMultiAssign}
                                        isLoading={multiReassignLoading}
                                        loadingText="Reassigning..."
                                        isDisabled={!multiAssignUserId || selectedLeads.length === 0 || multiReassignLoading}
                                    >
                                        Reassign
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </Modal>

                        {/* Revoke Lead Modal */}
                        <Modal
                            isOpen={isRevokeOpen}
                            onClose={() => {
                                if (!revokeLoading) {
                                    onRevokeClose();
                                    setRevokeReason("");
                                    setRevokeError("");
                                    setSelectedLead(null);
                                }
                            }}
                            isCentered
                            size="md"
                        >
                            <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(4px)" />
                            <ModalContent borderRadius="12px">
                                <ModalHeader fontSize="18px" fontWeight="600" borderBottom="1px solid" borderColor="gray.100" py={4}>
                                    Revoke Lead
                                </ModalHeader>
                                <ModalCloseButton isDisabled={revokeLoading} />

                                <ModalBody py={4}>
                                    {selectedLead && (
                                        <Box mb={4} p={3} bg="#FEF3F2" borderRadius="8px" border="1px solid #FECDCA">
                                            <Text fontSize="12px" color="#B42318" fontWeight="500">
                                                You are about to revoke this lead:
                                            </Text>
                                            <Text fontSize="13px" fontWeight="600" color="#912018" mt={0.5}>
                                                {selectedLead.companyName || ("Lead #" + (selectedLead.leadId || ""))}
                                                {selectedLead.pocName ? ` (${selectedLead.pocName})` : ""}
                                            </Text>
                                            <Text fontSize="11px" color="#B42318" mt={1}>
                                                Once revoked, this lead will no longer be considered pending acceptance or rejection.
                                            </Text>
                                        </Box>
                                    )}

                                    <Box mb={2}>
                                        <Flex justify="space-between" align="center" mb={2}>
                                            <Text fontSize="14px" fontWeight="500" color="gray.700">
                                                Revoke Reason <Text as="span" color="red.500">*</Text>
                                            </Text>
                                            <Text fontSize="12px" color={revokeReason.length > 2000 ? "red.500" : "gray.400"}>
                                                {revokeReason.length}/2000
                                            </Text>
                                        </Flex>
                                        <Textarea
                                            placeholder="Please enter the reason for revoking this lead (min. 3 characters)..."
                                            value={revokeReason}
                                            onChange={(e) => {
                                                setRevokeReason(e.target.value);
                                                if (revokeError && e.target.value.trim().length >= 3) {
                                                    setRevokeError("");
                                                }
                                            }}
                                            maxLength={2000}
                                            borderRadius="8px"
                                            fontSize="13px"
                                            rows={4}
                                            borderColor={revokeError ? "red.400" : "gray.200"}
                                            focusBorderColor={revokeError ? "red.500" : "blue.500"}
                                        />
                                        {revokeError && (
                                            <Text color="red.500" fontSize="xs" mt={1}>
                                                {revokeError}
                                            </Text>
                                        )}
                                    </Box>
                                </ModalBody>

                                <ModalFooter borderTop="1px solid" borderColor="gray.100" py={3} gap={3}>
                                    <Button
                                        variant="ghost"
                                        onClick={() => {
                                            onRevokeClose();
                                            setRevokeReason("");
                                            setRevokeError("");
                                            setSelectedLead(null);
                                        }}
                                        isDisabled={revokeLoading}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        colorScheme="red"
                                        onClick={handleRevokeLead}
                                        isLoading={revokeLoading}
                                        loadingText="Revoking..."
                                        isDisabled={revokeLoading || !revokeReason.trim() || revokeReason.trim().length < 3 || revokeReason.trim().length > 2000}
                                    >
                                        Submit
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </Modal>
                    </GridItem>
                </Grid>
            </Box>


        </MyDiv>
    );
};

export default MyLeadList;